import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';

// 根据通知id查通知
export function getNotice(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'common/staterunEnrolStudent/getNotice',
        method: 'post',
        data: params
    });
}
// 校验身份证号年龄段

export function checkCarId(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('cardId', args.cardId);

    return fetch({
        url: 'common/staterunEnrolStudent/checkCarId',
        method: 'post',
        data: params
    });
}

// 校验验证码
export function checkCode(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('code', args.code);
    params.append('mobile', args.mobile);

    return fetch({
        url: 'common/staterunEnrolStudent/checkCode',
        method: 'post',
        data: params
    });
}

// 根据通知Id,身份证号，手机号获取token
export function getTokenByIdCard(args) {
    let params = new URLSearchParams();
    params.append('idcard', args.idcard);
    params.append('noticeId', args.noticeId);
    params.append('mobile', args.mobile);
    params.append('schoolId', args.schoolId);

    return fetch({
        url: 'common/staterunEnrolStudent/getTokenByIdCard',
        method: 'post',
        data: params
    });
}

// 获取验证码
export function getCode(args) {
    let params = new URLSearchParams();
    params.append('mobile', args.mobile);
    params.append('noticeId', args.noticeId);
    params.append('schoolId', args.schoolId);

    return fetch({
        url: 'common/staterunEnrolStudent/getCode',
        method: 'post',
        data: params
    });
}

// 新增学生信息
export function insertStuInfo(args) {
    let params = new URLSearchParams();
    params.append('studentJson', args.studentJson);
    params.append('token', args.token);

    return fetch({
        url: 'common/staterunEnrolStudent/insertStuInfo',
        method: 'post',
        data: params
    });
}

// 修改和提交学生信息
export function updateStuInfo(args) {
    let params = new URLSearchParams();
    params.append('studentJson', args.studentJson);
    params.append('token', args.token);


    return fetch({
        url: 'common/staterunEnrolStudent/updateStuInfo',
        method: 'post',
        data: params
    });
}

// 根据token获取学生信息
export function getStuInfoByToken(args) {
    let params = new URLSearchParams();
    params.append('token', args.token);

    return fetch({
        url: 'common/staterunEnrolStudent/getStuInfoByToken',
        method: 'post',
        data: params
    });
}

// 根据当前年份year和schoolId 获取字段设置信息
export function getFieldSetInfo(args) {
    let params = new URLSearchParams();
    params.append('schoolId', args.schoolId);
    params.append('yearNo', args.yearNo);

    return fetch({
        url: 'common/staterunEnrolStudent/getFieldSetInfo',
        method: 'post',
        data: params
    });
}



// 根据通知Id,手机号 护照获取token
export function getTokenByPassport(args) {
    let params = new URLSearchParams();
    params.append('birthday', args.birthday);
    params.append('gender', args.gender);
    params.append('mobile', args.mobile);
    params.append('noticeId', args.noticeId);
    params.append('passport', args.passport);
    params.append('schoolId', args.schoolId);

    return fetch({
        url: `common/staterunEnrolStudent/getTokenByPassport`,
        method: 'post',
        data: params
    })
}

// 根据ID获得学校信息
export function queryById(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);

    return systemFetch({
        url: `common/school/queryById`,
        method: 'post',
        data: params
    })
}

// 新增学生信息
export function additionalStuInfo(args) {
    let params = new URLSearchParams();
    if(args.token) {
        params.append('token', args.token);
    }
    params.append('studentJson', args.studentJson);

    return fetch({
        url: 'common/staterunEnrolStudent/additionalStuInfo',
        method: 'post',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/primary/outer.js